import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiFormLabel-root': {
      color: theme.palette.grey9,
      ...theme.rccl.labelMicro,
    },
    '& .MuiFormLabel-filled + .MuiInputBase-root .MuiInputBase-input': {
      color: `${theme.palette.grey1} !important`,
    },
    '& .MuiInputAdornment-root': {
      background: theme.palette.grey4,
      height: 'auto',
      margin: '0',
      overflow: 'visible',
    },
    '& .Mui-error .MuiInputBase-input': {
      border: `1px solid ${theme.palette.critical}`,
    },
    '& .MuiInputBase-root.Mui-focused': {
      '& input': {
        border: `1px solid ${theme.palette.blue2}`,
      },
    },
    '& .MuiInput-input': {
      background: theme.palette.white,
      borderRadius: 3,
      border: `1px solid ${theme.palette.grey7}`,
      color: theme.palette.grey8,
      fontFamily: theme.typography.proxima.regular,
      fontSize: theme.typography.pxToRem('16'),
      opacity: 1,
      padding: `0 ${theme.typography.pxToRem(10)}`,
      '&::placeholder': {
        color: theme.palette.grey8,
        fontFamily: theme.typography.proxima.regular,
        fontSize: theme.typography.pxToRem('16'),
        opacity: 1,
      },
    },
    '& .MuiFormHelperText-root': {
      color: theme.palette.blue2,
      fontSize: theme.typography.pxToRem(10),
    },
    '& .MuiFormHelperText-root.Mui-error': {
      color: theme.palette.critical,
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(18),
    },
  },
  labelWithTooltip: {
    marginRight: theme.typography.pxToRem(8),
  },
}));

export default useStyles;
